import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import "./i18n";
import "@fontsource/montserrat/300.css";
import "@fontsource/montserrat/400.css";
import "@fontsource/montserrat/500.css";
import "@fontsource/montserrat/600.css";
import "@fontsource/montserrat/700.css";

import "./styles/tokens.css";
import "./styles/global.css";

const STORAGE = sessionStorage; // instead of localStorage
const KEY = "app_build_id";

async function checkForUpdate() {
  try {
    const res = await fetch("/version.json", { cache: "no-store" });
    const { buildId } = await res.json();

    const current = STORAGE.getItem(KEY);
    if (!current) return STORAGE.setItem(KEY, buildId);

    if (current !== buildId) {
      const confirm = window.confirm(
        "Une nueva versión de la aplicación está disponible. ¿Quieres recargar para actualizar?"
      );
      if (!confirm) return;
      STORAGE.setItem(KEY, buildId);
      window.location.reload();
    }
  } catch {}
}

checkForUpdate();
setInterval(checkForUpdate, 5 * 60 * 1000);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
